import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './table.action';

let table = { ...config };
table.url = '/tms/job';
table.filter = { status: 'active' };
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    width: 80,
    component: (row) => {
      return (
        <div>
          <div className="text-ellipsis">{row?.code}</div>
          <small className="text-ellipsis">
            {row?.ref_code ? `Kode Ref: ${row?.ref_code}` : null}
          </small>
        </div>
      );
    },
  },

  type: {
    title: 'Tipe',
    sortable: true,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <span
          className={
            row?.type === 'pickup'
              ? 'badge bg-dark-lt text-secodary ms-auto'
              : row?.type === 'console'
              ? 'badge bg-warning-lt text-warning ms-auto'
              : 'badge bg-primary-lt text-primary ms-auto'
          }
        >
          {row?.type?.replace('_', ' ').replace('console', 'transit')}
        </span>
      );
    },
  },

  ref_code: {
    title: 'Kode Ref',
    width: 100,
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {row?.shipment?.code || row?.booking?.code}
        </div>
      );
    },
  },

  origin: {
    title: 'Asal',
    sortable: true,
    alias: 'origin.name',
    width: 150,
    component: (row) => {
      return (
        <div>
          {row?.origin ? (
            <div>
              {row?.origin?.name === row?.origin?.contact_person ? (
                <div className="text-ellipsis">
                  {row?.origin?.contact_person} - {row?.origin?.phone_number}
                </div>
              ) : (
                <>
                  <div className="text-ellipsis">{row?.origin?.name}</div>
                  <small className="text-ellipsis">
                    {row?.origin?.contact_person} - {row?.origin?.phone_number}
                  </small>
                  <br />
                </>
              )}
              <small className="text-ellipsis">
                {row?.origin?.region
                  ? `${row?.origin?.region?.village_name},
                ${row?.origin?.region?.district_name},
                ${row?.origin?.region?.regency_name},
                ${row?.origin?.region?.province_name}`
                  : null}
              </small>
            </div>
          ) : (
            '-'
          )}
        </div>
      );
    },
  },
  destination: {
    title: 'Tujuan',
    sortable: true,
    alias: 'destination.name',
    class: 'text-start',
    width: 150,
    component: (row) => {
      return (
        <div>
          {row?.destination ? (
            <div>
              {row?.destination?.name === row?.destination?.contact_person ? (
                <div className="text-ellipsis">
                  {row?.destination?.contact_person} -{' '}
                  {row?.destination?.phone_number}
                </div>
              ) : (
                <>
                  <div className="text-ellipsis">{row?.destination?.name}</div>
                  <small className="text-ellipsis">
                    {row?.destination?.contact_person} -{' '}
                    {row?.destination?.phone_number}
                  </small>
                  <br />
                </>
              )}
              <small className="text-ellipsis">
                {row?.destination?.region
                  ? `${row?.destination?.region?.village_name},
                ${row?.destination?.region?.district_name},
                ${row?.destination?.region?.regency_name},
                ${row?.destination?.region?.province_name}`
                  : null}
              </small>
            </div>
          ) : (
            '-'
          )}
        </div>
      );
    },
  },
  schedule_at: {
    title: 'Tanggal',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 70,
    component: (row) => {
      return <div>{formatDate(row?.schedule_at, 'DD/MM/YYYY')}</div>;
    },
  },

  status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return (
        <span
          className={
            row?.status === 'new'
              ? 'badge bg-yellow-lt ms-auto'
              : row?.status === 'process'
              ? 'badge bg-primary-lt text-primary ms-auto'
              : row?.status === 'disputed'
              ? 'badge bg-danger-lt text-danger ms-auto'
              : 'badge bg-green-lt ms-auto'
          }
        >
          {row?.status}
        </span>
      );
    },
  },
  action: {
    title: '',
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};
export default table;
